import { NgModule } from '@angular/core';
import { ButtonBrowserBackComponent } from './button-browser-back.component';
import { CoreDirectivesModule } from '../../directives/core.directives.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';

@NgModule({
    declarations: [ButtonBrowserBackComponent],
    exports: [ButtonBrowserBackComponent],
    imports: [
        CoreDirectivesModule,
        MatButtonModule,
        MatIconModule,
        FlexLayoutModule
    ]
})
export class ButtonBrowserBackModule {
}
